import * as React from 'react';
import { FunctionComponent } from 'react';
import './Footer.scss';

const Footer: FunctionComponent = () => {
  return <div className="footer" />;
};

export default Footer;
